<template>
  <div>
    <div class="banner-zt">
      <el-carousel height="390px" v-if="type == 'index'">
        <el-carousel-item>
          <h3 class="small"><img src="../assets/img/ban1.jpg"/></h3>
        </el-carousel-item>
        <el-carousel-item>
          <h3 class="small"><img src="../assets/img/banner01.png" @click="getImg"/></h3>
        </el-carousel-item>
        <el-carousel-item>
          <h3 class="small"><img src="../assets/img/banner03.png" @click="getImg"/></h3>
        </el-carousel-item>
      </el-carousel>
      <img v-if="type == 'aboutUs'" src="../assets/img/about.jpg" class="banner-img" height="390px"/>
      <img v-if="type == 'service'" src="../assets/img/service.jpg" class="banner-img" height="390px"/>
      <img v-if="type == 'customer'" src="../assets/img/customer.jpg" class="banner-img" height="390px"/>
      <img v-if="type == 'contact_us'" src="../assets/img/SDbanner.jpg" class="banner-img" height="390px"/>
    </div>
    <div class="nav-zt">
      <div class="nav">
        <div class="logo-zt">
          <img src="../assets/img/ddlogo.png" width="260" height="61"/>
          <img src="../assets/img/ddlogo.png" width="260" height="61"/>
        </div>
        <ul class="menu">
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/news">新闻资讯</router-link></li>
          <li><router-link to="/service">点滴服务</router-link></li>
          <li><router-link to="/customer">客户案例</router-link></li>
          <li><router-link to="/aboutUs">关于我们</router-link></li>
          <li><router-link to="/contact_us">联系我们</router-link></li>
        </ul>
      </div>
    </div>
    <div class="navBar-zt" :class="navBarFixed == true ? 'navBarWrap' :''">
      <div class="nav">
        <div class="logo-zt">
          <img src="../assets/img/logo2.jpg" width="260" height="61"/>
        </div>
        <ul class="menu">
          <li><router-link to="/">首页</router-link></li>
          <li><router-link to="/news">新闻资讯</router-link></li>
          <li><router-link to="/service">点滴服务</router-link></li>
          <li><router-link to="/customer">客户案例</router-link></li>
          <li><router-link to="/aboutUs">关于我们</router-link></li>
          <li><router-link to="/contact_us">联系我们</router-link></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/styles/index.scss'
export default {
  name: 'headerItem',
  props: ["headerId"],
  data () {
    return {
      navBarFixed:false,
      type:this.headerId
    }
  },
  methods:{
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 90 时，实现吸顶效果
      if (scrollTop > 90) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    getImg(){
      this.$router.push({path:"/customer"});
    }
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  }
}
</script>



// WEBPACK FOOTER //
// src/components/header.vue